'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const LargeMatterFailureIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="LargeMatterFailureIcon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 35 35"
        id="Browser-Delete--Streamline-Core"
        height="35"
        width="35"
      >
        <g id="browser-delete--app-code-apps-fail-deleteWindowRemove-cross">
          <path
            id="Vector"
            fill="#D8DCE5"
            fillRule="evenodd"
            d="M5.233 1.25C3.0332500000000002 1.25 1.25 3.0332500000000002 1.25 5.233v24.533749999999998c0 2.2 1.7832500000000002 3.98325 3.9829999999999997 3.98325h24.534c2.19975 0 3.9829999999999997 -1.7832500000000002 3.9829999999999997 -3.98325V5.233C33.75 3.0332500000000002 31.966749999999998 1.25 29.767000000000003 1.25H5.233Z"
            clipRule="evenodd"
            strokeWidth="1"
          ></path>
          <path
            id="Vector_2"
            fill="#5073C3"
            d="M5.233 1.25C3.0332500000000002 1.25 1.25 3.0332500000000002 1.25 5.233V8.75h32.5V5.233C33.75 3.0332500000000002 31.966749999999998 1.25 29.767000000000003 1.25H5.233Z"
            strokeWidth="1"
          ></path>
          <path
            id="Union"
            fill="#5073C3"
            fillRule="evenodd"
            d="M13.825825 14.299175c-0.7322249999999999 -0.7322249999999999 -1.919425 -0.7322249999999999 -2.65165 0s-0.7322249999999999 1.919425 0 2.65165L14.84835 20.625 11.174175 24.299175c-0.7322249999999999 0.7323250000000001 -0.7322249999999999 1.9193250000000002 0 2.651575 0.7322249999999999 0.73225 1.919425 0.73225 2.65165 0L17.5 23.27665l3.674175 3.6741c0.7322249999999999 0.73225 1.919425 0.73225 2.65165 0s0.7322249999999999 -1.9192500000000001 0 -2.651575L20.15165 20.625l3.674175 -3.674175c0.7322249999999999 -0.7322249999999999 0.7322249999999999 -1.919425 0 -2.65165s-1.919425 -0.7322249999999999 -2.65165 0L17.5 17.97335 13.825825 14.299175Z"
            clipRule="evenodd"
            strokeWidth="1"
          ></path>
        </g>
      </svg>
    </SvgIcon>
  )
}

LargeMatterFailureIcon.propTypes = {
  sx: PropTypes.object
}
